import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Position of the "Filters" label + icon relative to the pill row: "inline"
// (beside the pills) or "top" (stacked above). Per-breakpoint for mobile wrap.
export default class FilterToolbarLabelPosition extends BaseOption {
  static label = "Filter Label Position";
  static userInterfaceComponent = {
    component: inspectorTools.RADIO_BAR,
    props: {
      options: [
        { value: "inline", label: "Inline" },
        { value: "top", label: "Top" },
      ],
    },
  };

  static defaultValue = "inline";
}
